<button class="side-button axs-button-vg-red" (click)="openSurvey()">
  {{sideButtonText}}
</button>
